import React, { useState, useEffect } from 'react';
import AdminAuth from './AdminAuth';
import AdminPanel from './AdminPanel';

const ProtectedAdmin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = () => {
    try {
      const authStatus = sessionStorage.getItem('adminAuthenticated');
      const authTime = sessionStorage.getItem('adminAuthTime');
      
      if (authStatus === 'true' && authTime) {
        // Check if session is still valid (24 hours)
        const sessionAge = Date.now() - parseInt(authTime);
        const maxSessionAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
        
        if (sessionAge < maxSessionAge) {
          setIsAuthenticated(true);
        } else {
          // Session expired, clear storage
          sessionStorage.removeItem('adminAuthenticated');
          sessionStorage.removeItem('adminAuthTime');
        }
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
    } finally {
      setIsChecking(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuthenticated');
    sessionStorage.removeItem('adminAuthTime');
    setIsAuthenticated(false);
  };

  if (isChecking) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <AdminAuth onLogin={handleLogin} />;
  }

  return <AdminPanel onLogout={handleLogout} />;
};

export default ProtectedAdmin;
